import { gql, useQuery } from "@apollo/client";

import Loader from "@/components/common/Loader/Loader";
import Content from "@/components/common/Content";
import handleServerSideProps from "src/lib/handle-server-side-props";

export async function getServerSideProps({ params, ...context }) {
  const { data, result } = await handleServerSideProps({
    context,
    pageQuery,
    variables: params,
    props: { category: params.category, slug: params.slug },
  });

  if (!data.blogPostBySlug) return { notFound: true };
  return result;
}

function BlogPostDetail({ category, slug }) {
  const { data } = useQuery(pageQuery, {
    variables: { category, slug },
  });

  if (!data) return <Loader />;

  return (
    <Content data={data.blogPostBySlug}>
      <article
        className="px-xl-5"
        dangerouslySetInnerHTML={{
          __html: data.blogPostBySlug.content,
        }}
      />
    </Content>
  );
}

export default BlogPostDetail;

const pageQuery = gql`
  query BlogPostBySlug($category: String!, $slug: String!) {
    blogPostBySlug(categorySlug: $category, slug: $slug) {
      title
      subtitle
      date
      category {
        categoryTitle
        slug
      }
      content
      image {
        url
        width
        height
      }
      authorDj {
        dj
        url
      }
      preview
      editUrl
    }
  }
`;
